<div hidden>
  <input type="file" id="attachmentUpload" (change)="selectFile($event)" multiple="multiple">
</div>

<mat-toolbar class="custom-toolbar">
  <mat-toolbar-row class="mat-elevation-z6" style="height:5px;" />
  <mat-toolbar-row class="mat-elevation-z6">

    <button mat-raised-button color="primary" routerLinkActive="active" [routerLink]="['/claims']" >
      <mat-icon>chevron_left</mat-icon>
    </button>

    <span>Edit claim {{this.claim.claim_no}}</span>
    <span class="example-spacer"></span>

    <div class="example-button-row">

      @if (this.showAcceptButton) {
        <button mat-raised-button color="primary" (click)="proceed('accept')"
          >
          <mat-icon>done_outline</mat-icon>{{this.claim.claim_status === 'CR' ? 'Release' : 'Accept'}}
        </button>
      }

      @if (this.showRejectButton) {
        <button mat-raised-button color="primary" (click)="proceed('reject')"
          >
          <mat-icon>cancel</mat-icon>{{this.claim.claim_status === 'CR' ? 'Delete' : 'Reject'}}
        </button>
      }

      @if ((this.isCustomer && ['CR'].includes(this.claim.claim_status)) ||
        (this.isSupplier && ['NW','AC-P'].includes(this.claim.claim_status))) {
        <button mat-raised-button color="primary" (click)="showSelectFileDialog()"
          >
          <mat-icon>attachment</mat-icon>Add attachment
        </button>
      }

    </div>

  </mat-toolbar-row>
  <mat-toolbar-row class="mat-elevation-z6" style="height:5px;" />

</mat-toolbar>

<app-my-loader />

<mat-card>

  <div class="mat-elevation-z1">

    <mat-card>
      <mat-card-title>Order data</mat-card-title>
      <table>
        <tr>
          <td style="width: 25%;">
            <mat-form-field style="width: 100%;">
              <mat-label>Claim No.</mat-label>
              <input [(ngModel)]="claim.claim_no" matInput disabled=true>
            </mat-form-field>
          </td>
          <td style="width: 25%;">
            <mat-form-field style="width: 100%;">
              <mat-label>Claim Status</mat-label>
              <input [(ngModel)]="claim.claim_status" matInput disabled=true>
            </mat-form-field>
          </td>
          <td style="width: 25%;">
            <mat-form-field style="width: 100%;">
              <mat-label>Order No.</mat-label>
              <input [(ngModel)]="claim.order_no" matInput disabled=true>
            </mat-form-field>
          </td>
          <td>
            <mat-form-field style="width: 100%;">
              <mat-label>Order Line No.</mat-label>
              <input [(ngModel)]="claim.order_line_no" matInput disabled=true>
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td>
            <mat-form-field style="width: 100%;">
              <mat-label>GA Supplier (No. / Name)</mat-label>
              <input [(ngModel)]="claim.supplier_name" matInput
                disabled=true>
              </mat-form-field>
            </td>
            <td>
              <mat-form-field style="width: 100%;">
                <mat-label>Customer (No. / Name)</mat-label>
                <input [(ngModel)]="claim.customer_name" matInput
                  disabled=true>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="width: 100%;">
                  <mat-label>Item</mat-label>
                  <input [(ngModel)]="claim.item_name" matInput disabled=true>
                </mat-form-field>
              </td>
              <td>
                <mat-form-field style="width: 50%;">
                  <mat-label>Dispatched qty</mat-label>
                  <input [(ngModel)]="claim.dispatched_qty" matInput
                    disabled=true>
                  </mat-form-field>
                  <mat-form-field style="width: calc(50% - 10px); margin-left: 10px;">
                    <mat-label>Unloaded qty</mat-label>
                    <input [(ngModel)]="claim.unloaded_qty" matInput
                      disabled=true>
                    </mat-form-field>
                  </td>
                </tr>
              </table>
            </mat-card>
          </div>

          <div class="mat-elevation-z1" style="margin-top: 10px;">
            <mat-card>
              <mat-card-title>Claim data</mat-card-title>
              <table>
                <tr>
                  <td>
                    <mat-form-field style="width: 100%;">
                      <mat-label>Claimed qty </mat-label>
                      <input [(ngModel)]="claim.claimed_qty" matInput [disabled]="!this.isCustomer || this.claim.claim_status !== 'CR'" (keyup)="updateCost()">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field style="width: 50%;">
                      <mat-label>Claimed cost</mat-label>
                      <input [(ngModel)]="claim.claimed_cost" matInput [disabled]="true">
                    </mat-form-field>

                    <mat-form-field style="width: 50%;">
                      <mat-label>Currency *</mat-label>
                      <input [(ngModel)]="claim.currency" matInput [disabled]="true">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field style="width: 100%;">
                      <mat-label>Manual claimed cost</mat-label>
                      <input [(ngModel)]="claim.manual_claimed_cost" matInput [disabled]="!this.isCustomer || this.claim.claim_status !== 'CR'">
                    </mat-form-field>
                  </td>
                  <td class='select-td'>
                    <mat-form-field style="width: 100%;">
                      <mat-label>Claim reason code *</mat-label>

                      @if (this.claim.claim_status === 'CR') {
                        <mat-select [(ngModel)]='this.claim_reason_code_ids' [ngModelOptions]="{standalone: true}" multiple (selectionChange)="selectionChanged($event)">
                          @for (crc of claim_reason_codes; track crc) {
                            <mat-option [value]="crc.id">
                              {{crc.name}}
                            </mat-option>
                          }
                        </mat-select>
                      }

                      @if (this.claim.claim_status !== 'CR') {
                        <input [(ngModel)]="claim.claim_reason_code" matInput [disabled]="true">
                      }

                    </mat-form-field>
                    @if (this.showHint && this.claim.claim_status === 'CR') {
                      <mat-error>Others - please specify in customer's comments.</mat-error>
                    }
                  </td>
                  <td>
                        <mat-checkbox [disabled]="!(this.isCustomer && this.claim.claim_status === 'CR') &&
                        !(this.isPNE && this.claim.claim_status === 'AC-GA')" [(ngModel)]="claim.safety_alarm">Safety alarm</mat-checkbox>
                  </td>
                </tr>
                <tr>
                  @if (this.isCustomer) {
                    <td colspan="2">
                      <mat-form-field style="width: 100%;">
                        <mat-label>Customer comments</mat-label>
                        <input [(ngModel)]="claim.customers_comments" matInput [disabled]="!['CR','RJ-GA'].includes(this.claim.claim_status)">
                      </mat-form-field>
                    </td>
                  }
                  @if (this.isSupplier) {
                    <td colspan="2">
                      <mat-form-field style="width: 100%;">
                        <mat-label>GA Supplier comments</mat-label>
                        <input [(ngModel)]="claim.suppliers_comments" matInput [disabled]="!['NW','AC-P'].includes(this.claim.claim_status)">
                      </mat-form-field>
                    </td>
                  }
                  <td colspan="2">
                    <mat-form-field style="width: 100%;">
                      <mat-label>Suggested actions</mat-label>
                      <input [(ngModel)]="claim.suggested_actions" matInput [disabled]="!this.isCustomer || this.claim.claim_status !== 'CR'">
                    </mat-form-field>
                  </td>
                  @if (this.isPNE) {
                    <td colspan="2"></td>
                  }
                  <td>
                    @if ((this.isCustomer && ['CR','RJ-GA'].includes(this.claim.claim_status)) ||
                      (this.isSupplier && ['NW','AC-P'].includes(this.claim.claim_status)) ||
                      (this.isPNE && this.claim.claim_status === 'AC-GA')) {
                      <div>
                        <button mat-button (click)="saveClaim()">
                          <mat-icon class="button-bar-icon">save</mat-icon> Save
                        </button>
                        <button mat-button [routerLink]="['/claims']">
                          <mat-icon class="button-bar-icon">cancel</mat-icon> Cancel
                        </button>
                      </div>
                    }
                  </td>
                </tr>

              </table>
            </mat-card>
          </div>


          <table>
            <tr>
              <td width="50%" class="attachment-td">
                <div class="mat-elevation-z1" style="margin-top: 10px;">
                  <mat-card>
                    <mat-card-title>Customer attachments</mat-card-title>

                    @for (a of customer_attachments; track a) {
                      <a mat-raised-button target="_blank" href="{{a.path}}" class="link-btn" (contextmenu)="deleteCustomerAttachment($event, a.id)"
                        title="{{ (this.isCustomer && ['CR'].includes(this.claim.claim_status)) ? 'Right click to delete' : '' }}">
                        <mat-icon>{{a.icon}}</mat-icon>{{a.original_filename}}
                      </a>
                    }
                  </mat-card>
                </div>
              </td>
              <td width="50%" class="attachment-td">

                <div class="mat-elevation-z1" style="margin-left: 10px; margin-top: 10px;">
                  <mat-card>
                    <mat-card-title>GA Supplier attachments</mat-card-title>

                    @for (a of supplier_attachments; track a) {
                      <a mat-raised-button target="_blank" href="{{a.path}}" class="link-btn" (contextmenu)="deleteSupplierAttachment($event, a.id)"
                        title="{{ (this.isSupplier && ['NW', 'AC-P'].includes(this.claim.claim_status)) ? 'Right click to delete' : '' }}">
                        <mat-icon>{{a.icon}}</mat-icon>{{a.original_filename}}
                      </a>
                    }
                  </mat-card>
                </div>
              </td>
            </tr>
          </table>

        </mat-card>
